import Service from './common/services/Service';

let service = new Service();


$(document).on('turbo:load turbo:render', () => {
    let i = $('.search-select');

    i.each((index, element) => {
        let $el = $(element);

        //Remove previous select2 if using back button
        if ($el.next("span.select2-container").length) {
            $el.next("span.select2-container").remove();
        }
        let extraType = $el.data("extra-type");
        let searchType = $el.data('search-type');
        let active = $el.data('search-active');
        let placeholder = $el.data('search-placeholder');
        let dropdown = $el.data('dropdown');
        let lobbyist_registration_id = $el.data('lobbyistRegistrationId');
        let user_id = $el.data('userId');
        let entity_id = $el.data('entityid');


        //@ts-ignore
        $el.select2({
            placeholder: placeholder,
            theme: "bootstrap-5",
            // templateSelection: selectionFormat,
            ajax: {
                url: function () {
                    if (searchType == "admin-entity") {
                        return `/${searchType}/search?entity_id=${entity_id}`
                    } else {
                        return `/${searchType}/search`
                    }
                },
                dataType: 'json',
                data: (params) => {
                    let query = {
                        keyword: params.term,
                        type: searchType,
                        active: active,
                        authenticity_token: service.csrfToken()
                    };

                    // Query parameters will be ?search=[term]&type=public
                    return query;
                },
                processResults: (data) => {
                    return {
                        results: data.message.map((i) => {
                            if (extraType == "filter") {
                                return {
                                    "id": i.name,
                                    "text": i.name,
                                    "address": i.street,
                                    "city": i.city,
                                    "state": i.state,
                                    "zip": i.zip,
                                    "website": i.website,
                                    "phone": i.phone,
                                    "nature_of_business": i.nature_of_business,
                                    "lobbyist_registration_id": lobbyist_registration_id,
                                    "user_id": user_id,
                                    "entity_id": entity_id
                                }
                            } else {
                                return {
                                    "id": i._id,
                                    "text": i.name,
                                    "address": i.street,
                                    "city": i.city,
                                    "state": i.state,
                                    "zip": i.zip,
                                    "website": i.website,
                                    "phone": i.phone,
                                    "nature_of_business": i.nature_of_business,
                                    "lobbyist_registration_id": lobbyist_registration_id,
                                    "user_id": user_id,
                                    "entity_id": entity_id
                                }
                            }

                        })
                    };
                },
                // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
            },
            templateResult: (i) => {
                if (!i.id || searchType != "admin-entity") {
                    return i.text
                }
                let address = ``;
                if (i.address) {
                    address += `${i.address}`;
                }
                if (i.city) {
                    address += `, ${i.city}`;
                }
                if (i.state) {
                    address += `, ${i.state}`;
                }
                if (i.zip) {
                    address += `, ${i.zip}`;
                }
                return $(`<div class="row"><div class="col-md-5">${i.text}</div><div class="col-md-7"><div class="align-right">${address}</div></div></div>`)
            },
            minimumInputLength: 2,

            // allowClear: true,
            //@ts-ignore
            selectionAdapter: $.fn.select2.amd.require("CustomSelectionAdapter"),
            dropdownParent: $(dropdown),

        });
    });

    i.on('select2:open', (e) => {
        let type = $(`${e.target.dataset.dropdown}`).data().type;
        let showAddEntityButton =  e.target.dataset.showAddEntityButton;
        if (type != "organization" && showAddEntityButton !== "false") {
            appendAddEntityButton(type, i);
        }
    });
    i.on("select2:closing", (e) => {
        let showAddEntityButton =  e.target.dataset.showAddEntityButton;
        let type = $(`${e.target.dataset.dropdown}`).data().type;
        if (type != "organization" && showAddEntityButton !== "false") {
            removeAddEntityButton(type);
        }
    });
    i.on("select2:unselect", (e) => {
        let type = $(`${e.target.dataset.dropdown}`).data().type;
        if (type == "admin-entity") {
            $("#employer-profile-selected-employer-data").empty();
        } else {
            let $information = $(".selected-result-information").first();
            $information.remove();
        }

    });

    i.on('select2:select', (e) => {
        let type = $(`${e.target.dataset.dropdown}`).data().type;
        let data = (<any>e).params.data;
        hideAndDisableEntityForm();
        let $information = createResultsCard(data, type);
        let selectedCard;
        if (type == "entity") {
            $("#selected-entity-data").empty();

            selectedCard = $("#selected-entity-data");
        } else if (type == "employer") {
            $("#selected-employer-data").empty();
            selectedCard = $("#selected-employer-data");

        } else if (type == "admin-entity") {
            $("#employer-profile-selected-employer-data").empty();
            selectedCard = $("#employer-profile-selected-employer-data");

        } else {
            $(".selected-result-information").each(function () {
                $(this).remove()
            });
            selectedCard = $('#selected-organization-data');
        }
        selectedCard.append($information);
        $(document).trigger("fieldsAdded");
        if (type == "employer") {
            appendChangeAddressButton(data, type);
        }
    });
});


function createResultsCard(data, type) {
    if (type == "organization") {
        return generateOrganizationCard(data)
    } else if (type == "admin-entity") {
        return generateEntityAdminCard(data)
    } else {
        return generateEntityCard(data)
    }
}


function removeAddEntityButton(type) {
    if (type != "admin-entity") {
        let $button;
        if (type == "entity") {
            $button = $("#entity-search-dropdown").find("#revealAddEntity");
        } else if (type == "employer") {
            $button = $("#employer-search-dropdown").find("#revealAddEntity");
        }
        if ($button) {
            $button.remove();

        }
    }
}

function appendAddEntityButton(type, selectSearch) {
    if (type != "admin-entity") {
        let $button = $('<button id="revealAddEntity" type="button">Add New</button>');
        $button.on("click", () => {
            toggleEntityForm();
            //@ts-ignore
            $(selectSearch).select2('close');
            $(selectSearch).val(null).trigger("change");
            //Removes card for previously selected entity
            $("#selected-entity-data").empty();
            $("#selected-employer-data").empty();
        });
        if (type == "entity") {
            $("#entity-search-dropdown .select2-results").append($button);

        } else if (type == "employer") {
            $("#employer-search-dropdown .select2-results").append($button);
        }
    }
}

function toggleEntityForm() {
    $(".entity-info").toggle();
    let $select = $('.entity-info').find("select");
    if ($select.is(":hidden")) {
        $select.prop("disabled", true);
    } else if ($select.is(":visible")) {
        $select.prop("disabled", false);

    }
    $('.entity-info').find('input').each(function () {
        //your code here
        if ($(this).is(":hidden")) {
            $(this).prop("disabled", true);
        } else if ($(this).is(":visible")) {
            $(this).prop("disabled", false);

        }
    });
}

function hideAndDisableEntityForm() {
    $(".entity-info").hide();
    let $select = $('.entity-info').find("select");
    $select.prop("disabled", true);

    $('.entity-info').find('input').each(function () {
        //your code here
        $(this).prop("disabled", true);

    });
}


function appendChangeAddressButton(data, type) {
    let $changeAddressButton = $(`<div class="col-md-12">
        <a class="change-address-button" data-remote="true" rel="nofollow" data-method="post" 
            href="/user/${data.user_id}/lobbyist_registrations/${data.lobbyist_registration_id}/add_entity_address?entity_id=${data.id}">
            Change address if different from above</a></div>`);

    $(`#addressFields${data.id}`).append($changeAddressButton);
}

function generateOrganizationCard(data) {
    return $(`
            <div class="selected-result-information" id="${data.id}">
           
                <div class="dynamic-show card">
                    <div class="row">
                        <div class="col-md-6">
                            <p>Name of Organization</p>
                            <p><strong>${data.text}</strong></p> 
                        </div>
                         <div class="col-md-6">
                            <p>Website</p>
                            <p><strong>${data.website}</strong></p> 
                        </div>
                    </div>
                    <div class = "row" id ="">
                        <div class="col-md-6">
                            <p>Address</p>
                            <p><strong>${data.address}, ${data.city} ${data.state} ${data.zip}</strong></p> 
                        </div>
                         <div class="col-md-6">
                            <p>Phone</>
                            <p><strong>${data.phone}</strong></p> 
                        </div>
                    </div>
                </div>
            </div>`);
}

function generateEntityCard(data) {
    return $(`
            <div class="selected-result-information" id="${data.id}">
                <div class="dynamic-show card">
                    <div class="row">
                        <div class="col-md-6">
                            <p>Name of Organization</p>
                            <p><strong>${data.text}</strong></p> 
                        </div>
                         <div class="col-md-6">
                            <p>Website</p>
                            <p><strong>${data.website}</strong></p> 
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>Nature of Business</p>
                            <p><strong>${data.nature_of_business}</strong></p> 
                        </div>
                    </div>
                    <div class="row" id="addressFields${data.id}">
                        <div class="col-md-6">
                            <p>Address</p>
                            <p><strong>${data.address}, ${data.city} ${data.state} ${data.zip}</strong></p> 
                        </div>
                         <div class="col-md-6">
                            <p>Phone</p>
                            <p><strong>${data.phone}</strong></p> 
                        </div>
                    </div>
                </div>
            </div>`);

}

function generateEntityAdminCard(data) {
    let website = "N/A";
    if (data.website) {
        website = data.website;
    }
    return $(`
    <section class="container">
        <div class="row">
            <div class="col-md-8"> 
              <a href="/admin/entities/${data.id}">
                 <h3>${data.text}</h3>
             </a>
            </div>
            <div class="col-md-4 align-right">
              <a class="btn brown" href="/admin/entities/${data.entity_id}/replace_employer_confirmation?replacement_id=${data.id}">
                     Replace with this Employer
              </a>
            </div>
        </div>
        <hr>
            <div class="row">
                <div class="col-md-6">
                    <p>Address: <strong>${data.address}, ${data.city}, ${data.state}, ${data.zip}</strong></p>
                </div>
                <div class="col-md-6">
                    <p>Phone: <strong>${data.phone}</strong></p>
                </div>
            </div> 
              <div class="row">
                <div class="col-md-6">
                    <p>Nature of Business: <strong>${data.nature_of_business}</strong></p>
                </div>
                <div class="col-md-6">
                    <p>Website: <strong>${website}</strong></p>
                </div>
            </div> 
    </section>`)
}
